import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../components/Spinner';
import {setTokenHeader} from '../../config/axios';
import {pathnames as P} from '../../constants/pathnames';
import types from '../../types';
import {sessionStorageKeys as S} from '../../constants/sessionStorageKeys';
import {setSessionStorageItem} from '../../utils/sessionStorage';
import styles from './styles.module.scss';

const Registration = ({setRegType, location, history}) => {
  const query = new URLSearchParams(location.search);
  const token = query.get('token');
  const regType = query.get('regType');
  if (!token || !regType) history.push(P.HOME);
  setSessionStorageItem(S.TOKEN, token);

    Promise.resolve()
    .then(() => setTokenHeader(token))
    .then(() => setRegType(regType))
    .then(() => history.replace(P.GET_STEP_PATH(1)));

  return (
    <div className={styles.container}>
      <Spinner/>
    </div>
  )
};

Registration.propTypes = {
  ...types.router,
  getNextStep: PropTypes.func,
  setRegType: PropTypes.func,
};

export default Registration;
